/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadMultiplePdfs
// UPLOADMULTIPLEPDFS
const UPLOADMULTIPLEPDFS= createAsyncThunk(
  "uploadMultiplePdfs/uploadMultiplePdfs",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const uploadMultiplePdfsSlice = createSlice({
  name: "uploadMultiplePdfsSlice",
  initialState: {
    uploadMultiplePdfs: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfuploadMultiplePdfs: (state) => {
        state.uploadMultiplePdfs.loading = false
        state.uploadMultiplePdfs.error = false
        state.uploadMultiplePdfs.data = []
        state.uploadMultiplePdfs.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPLOADMULTIPLEPDFS.fulfilled, (state, action) => {
      state.uploadMultiplePdfs = {
        ...state.uploadMultiplePdfs,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPLOADMULTIPLEPDFS.pending, (state, action) => {
      state.uploadMultiplePdfs = {
        ...state.uploadMultiplePdfs,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPLOADMULTIPLEPDFS.rejected, (state, action) => {
      state.uploadMultiplePdfs = {
        ...state.uploadMultiplePdfs,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const uploadMultiplePdfsAction = {
    UPLOADMULTIPLEPDFS,
};

export { uploadMultiplePdfsAction };
export default uploadMultiplePdfsSlice.reducer;
export const {setInitialStateOfuploadMultiplePdfs} = uploadMultiplePdfsSlice.actions